var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-datepicker" },
    [
      _c("ui-input", {
        ref: "input",
        attrs: {
          clearable: "",
          label: _vm.label,
          required: _vm.required,
          placeholder: "дд.мм.гггг",
          autocomplete: "off",
          mask: "date",
          validate: _vm.validate
        },
        on: { blur: _vm.onBlur },
        model: {
          value: _vm.localValue,
          callback: function($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }